import { RequestState } from '@redux/videoPlayerResources/types';

const PREVIEW_MENTION_SLIDE_ENDTIME_IN_SECONDS = 2;

const DELAY_FOR_PREVIEW_SONG_IN_SECONDS = 60 - PREVIEW_MENTION_SLIDE_ENDTIME_IN_SECONDS;

const VIDEO_RATIO = 16 / 9;

export const getPixelSizeNumberFromSizingFactor = (
  videoAreaHeight: number,
  sizingFactor: number,
): number => {
  return videoAreaHeight * sizingFactor;
};

export const getPreviewTime = (timeInSeconds: number) => {
  return timeInSeconds < PREVIEW_MENTION_SLIDE_ENDTIME_IN_SECONDS
    ? timeInSeconds
    : timeInSeconds + DELAY_FOR_PREVIEW_SONG_IN_SECONDS;
};

export const getCurrentTimeInSong = (videoElement: HTMLVideoElement, isPremium: boolean) => {
  return isPremium ? videoElement.currentTime : getPreviewTime(videoElement.currentTime);
};

export const allRessourcesLoaded = (
  lyricsState: RequestState,
  swipeColorsState: RequestState,
  videoMetadataState: RequestState,
) =>
  lyricsState === RequestState.success &&
  swipeColorsState === RequestState.success &&
  videoMetadataState === RequestState.success;

export const getVideoSize = (
  videoAreaWidth: number,
  videoAreaHeight: number,
  isDesktop: boolean,
) => {
  const heightFromWidth = videoAreaWidth / VIDEO_RATIO;
  const widthFromHeight = videoAreaHeight * VIDEO_RATIO;

  if (isDesktop && heightFromWidth > videoAreaHeight) {
    return { videoHeight: videoAreaHeight, videoWidth: widthFromHeight };
  }

  return { videoHeight: heightFromWidth, videoWidth: videoAreaWidth };
};
